<!-- <p-toast></p-toast> -->
<p-tabMenu [model]="items" [activeItem]="items[0]" class="mb-2">
</p-tabMenu>
<router-outlet></router-outlet>